"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var StyleTileV2_1 = __importDefault(require("DreamCoat/SavedStyle/StyleTileV2/StyleTileV2"));
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var UpdateStyleModalStore = (function () {
    function UpdateStyleModalStore() {
        var _this = this;
        this.setSelectedId = function (selectedId) {
            if (_this.isUpdateType(selectedId)) {
                _this._selectedId = selectedId;
            }
            else {
                throw new Error("Given a non-UpdateType to selectedId: ".concat(selectedId));
            }
        };
        this.isUpdateType = function (id) {
            if (Object.values(commonTypes_1.UpdateType).includes(id)) {
                return true;
            }
            else {
                return false;
            }
        };
        this._selectedId = commonTypes_1.UpdateType.All;
    }
    Object.defineProperty(UpdateStyleModalStore.prototype, "selectedId", {
        get: function () {
            return this._selectedId;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof commonTypes_1.UpdateType !== "undefined" && commonTypes_1.UpdateType) === "function" ? _a : Object)
    ], UpdateStyleModalStore.prototype, "_selectedId", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], UpdateStyleModalStore.prototype, "selectedId", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], UpdateStyleModalStore.prototype, "setSelectedId", void 0);
    return UpdateStyleModalStore;
}());
var UpdateStyleHeader = (function (_super) {
    __extends(UpdateStyleHeader, _super);
    function UpdateStyleHeader() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.options = [
            {
                id: commonTypes_1.UpdateType.All,
                label: "Update both existing and new blocks using this style",
            },
            {
                id: commonTypes_1.UpdateType.New,
                label: "Update only new blocks using this style",
            },
        ];
        return _this;
    }
    UpdateStyleHeader.prototype.render = function () {
        return (react_1.default.createElement("header", { className: "header" },
            react_1.default.createElement("div", { className: "center" },
                react_1.default.createElement(StyleTileV2_1.default, { style: this.props.style, size: "large", colors: this.props.brandStore.allColors })),
            react_1.default.createElement("h3", { className: "title" }, "Update this style"),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "explainer" }, "Choose how you\u2019d like to update your style:")),
            react_1.default.createElement("div", null,
                react_1.default.createElement(kaleidoscope_1.RadioButtonGroup, { options: this.options, onClickHandler: this.props.store.setSelectedId, selectedId: this.props.store.selectedId }))));
    };
    UpdateStyleHeader = __decorate([
        mobx_react_1.observer
    ], UpdateStyleHeader);
    return UpdateStyleHeader;
}(react_1.default.Component));
exports.default = (function (modal, savedStyleService, $log, environment, di, brandStore) {
    return function (style) { return __awaiter(void 0, void 0, void 0, function () {
        var store, header, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (environment !== "production") {
                        $log.log("Deleting Style:", style);
                    }
                    store = new UpdateStyleModalStore();
                    header = react_1.default.createElement(UpdateStyleHeader, { style: style, store: store, brandStore: brandStore });
                    return [4, modal.showConfirmModal({
                            header: header,
                            confirmLabel: "Update Style",
                            confirming: function () {
                                if (di.has("project")) {
                                    return savedStyleService.updateStyle(style, di.get("project"), store.selectedId);
                                }
                                else {
                                    throw new Error("Looks like something's gone wrong. Try again?");
                                }
                            },
                        })];
                case 1:
                    response = _a.sent();
                    if (response) {
                        return [2, store.selectedId];
                    }
                    return [2];
            }
        });
    }); };
});
